import { ESCAPE_KEY } from '../../const/keyNames';
/**
 * Map handlers to keyboard events, like escaping
 *
 * @param e Keyboard Event
 * @param KeyHandlers list of handlers per key
 * @returns the function being executed
 */
export default function KeyHandler(e, { escapeHandler = (ev) => ev }) {
    /** Using map to make it easy to support other future keys */
    const keyListenersMap = new Map([
        // escape key
        [ESCAPE_KEY, escapeHandler]
    ]);
    /** ...and implementing those keys */
    const listener = keyListenersMap.get(e.key);
    return listener && listener(e);
}
